type Prompt = () => Promise<boolean>;
let prompt: Prompt | null = null;
const approved = new WeakMap<FormData, Blob>();

export function registerPhotoSafetyPrompt(handler: Prompt): () => void {
  prompt = handler;
  return () => { if (prompt === handler) prompt = null; };
}

/** Permission is scoped to these upload bytes, never saved as an account preference. */
export async function confirmPhotoUpload(body: FormData): Promise<void> {
  const photos = ['image', 'avatar', 'logo', 'flyer'].flatMap(key => body.getAll(key)).filter(value => value instanceof Blob) as Blob[];
  if (!photos.length) return;
  if (photos.length !== 1) throw new Error('Upload one photo at a time.');
  const photo = photos[0];
  if (approved.get(body) === photo) return;
  if (!prompt || !(await prompt())) throw new Error('Photo upload canceled. Your photo was not sent.');
  const current = ['image', 'avatar', 'logo', 'flyer'].flatMap(key => body.getAll(key)).filter(value => value instanceof Blob);
  if (current.length !== 1 || current[0] !== photo) throw new Error('The photo changed. Please start the upload again.');
  body.set('safety_check_consent', '1');
  approved.set(body, photo);
}
